import { __rest } from "tslib";
import React from 'react';
import { withComponentDependency } from "./../../ComponentDependency/withComponentDependency";
export var ValuationFlowWidget = function ValuationFlowWidget(_a) {
  var ValuationFlow = _a.ValuationFlow,
    restProps = __rest(_a, ["ValuationFlow"]);
  if (!ValuationFlow) {
    return null;
  }
  return /*#__PURE__*/React.createElement(ValuationFlow, Object.assign({}, restProps));
};
export default withComponentDependency(ValuationFlowWidget);